import { featureConstant, isFeatureEnabled } from '@/config/features'

/**
 * Whether a feature is on. Same call shape as pitstop-ui's `useFeature`, so a
 * component ported from there needs no edit; see src/config/features.js for
 * where the list comes from.
 */
const useFeature = featureName => isFeatureEnabled(featureName)

export const features = featureConstant

export default useFeature
